export const FinancingActions = {
    SET_FINANCING_INITIAL_TAB: 'SET_FINANCING_INITIAL_TAB'
} as const;

export type FinancingActionType = (typeof FinancingActions)[keyof typeof FinancingActions];
